// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"95cef221","453":"17c7854e","821":"83e4a45d"}[chunkId] + ".chunk.js";
};